// The section renders its own <script> tag, so a page with more than one Chord
// Intro executes this file once per instance. Guard so the timelines are only
// built once — duplicates fight each other and leave the arcs stuck.
if (window.__chordIntroInit) {
  console.warn('chord-intro.js already initialised — skipping duplicate run');
} else {
  window.__chordIntroInit = true;

  document.addEventListener('DOMContentLoaded', function () {
    let mm = gsap.matchMedia();

    mm.add('(min-width: 768px)', () => {
      // Everything inside here only runs at 768px and above.
      // Build a timeline PER section — a page can contain more than one Chord Intro
      // (e.g. the About page uses it twice), and global selectors would trigger on
      // the first section while animating every section's lines at once.
      const timelines = [];

      document.querySelectorAll('.intro-section').forEach((section) => {
        const linesSvg = section.querySelector('.intro-section-lines');
        const morphs = section.querySelectorAll('.intro-section-lines .morph');
        if (!linesSvg || !morphs.length) return;

        const HeroTl = gsap.timeline({
          scrollTrigger: {
            trigger: section,
            start: 'clamp(top 90%)',
            end: 'clamp(bottom 55%)',
            scrub: 1.07,
            invalidateOnRefresh: true,
          },
        });

        HeroTl.to(morphs, {
          morphSVG: (i, target) => {
            const arcs = [
              'M 22 330 A 250 250 0 0 1 578 330',
              'M 44 330 A 200 200 0 0 1 556 330',
              'M 66 330 A 150 150 0 0 1 534 330',
              'M 88 330 A 100 100 0 0 1 512 330',
              'M 110 330 A 50 50 0 0 1 490 330',
            ];
            return arcs[i];
          },
          y: 0,
          transformOrigin: 'center center',
          duration: 1,
          ease: 'power4.inOut',
          opacity: 0.3,
        });

        HeroTl.to(linesSvg, { width: '780px' }, '<0.4');

        HeroTl.to(
          morphs,
          {
            strokeDasharray: '4.7 4.7',
          },
          '<0.05'
        );

        timelines.push(HeroTl);
      });

      return () => timelines.forEach((tl) => tl.scrollTrigger && tl.scrollTrigger.kill());
    });
  });
}

// old code below
// document.addEventListener('DOMContentLoaded', function () {
//   const mm = gsap.matchMedia();

//   // --- Define your conditions ---
//   mm.add(
//     {
//       // no animation on mobile
//       isMobile: '(max-width: 767px)',
//       isTablet: '(min-width: 768px) and (max-width: 1023px)',
//       isLaptop: '(min-width: 1024px) and (max-width: 1199px)',
//       isDesktop: '(min-width: 1200px)',
//       isLargeDesktop: '(min-width: 1600px)',
//     },
//     (context) => {
//       let { isMobile, isTablet, isLaptop, isDesktop, isLargeDesktop } = context.conditions;

//       // 💡 Exit early for mobile
//       if (isMobile) return;

//       // Default values
//       let scaleX = 1.05;
//       let yPoint = 350;

//       // Set values based on breakpoint
//       if (isTablet) {
//         scaleX = 0.75;
//       } else if (isLaptop) {
//         scaleX = 0.6;
//       } else if (isDesktop) {
//         scaleX = 0.46;
//       } else if (isLargeDesktop) {
//         scaleX = 0.26;
//         yPoint = 250;
//       } else {
//         scaleX = 1.05;
//         yPoint = 420;
//       }

//       // --- GSAP Timeline ---
//       const HeroTl = gsap.timeline({
//         scrollTrigger: {
//           trigger: '.intro-section',
//           start: 'top 90%',
//           end: 'bottom 55%',
//           scrub: 1.07,
//           // markers: true,
//         },
//       });

//       HeroTl.to('.intro-section-lines .morph', {
//         morphSVG: (i) => {
//           const arcs = [
//             'M 22 250 A 250 250 0 0 1 578 250',
//             'M 44 250 A 200 200 0 0 1 556 250',
//             'M 66 250 A 150 150 0 0 1 534 250',
//             'M 88 250 A 100 100 0 0 1 512 250',
//             'M 110 250 A 50 50 0 0 1 490 250',
//           ];
//           return arcs[i];
//         },
//         y: yPoint,
//         scaleX: scaleX,
//         transformOrigin: 'center center',
//         duration: 1,
//         ease: 'power4.inOut',
//         opacity: 0.3,
//       });

//       HeroTl.to(
//         '.intro-section-lines .morph',
//         {
//           strokeDasharray: '4.7 4.7',
//         },
//         '<0.4'
//       );
//     }
//   );
// });

// document.addEventListener('DOMContentLoaded', function () {
//   // Disable on mobile (<768px)
//   if (window.matchMedia('(max-width: 767px)').matches) {
//     return; // Stop execution entirely on mobile
//   }

//   gsap.registerPlugin(ScrollTrigger, MorphSVGPlugin);

//   let scaleX = 1.05;
//   let yPoint = 350;

//   // Define breakpoints
//   const breakpoints = [
//     { mq: window.matchMedia('(min-width: 768px) and (max-width: 1023px)'), scale: 0.75 },
//     { mq: window.matchMedia('(min-width: 1024px) and (max-width: 1199px)'), scale: 0.6 },
//     { mq: window.matchMedia('(min-width: 1200px)'), scale: 0.46 },
//   ];

//   // Handler function
//   function handleBreakpointChange() {
//     for (const bp of breakpoints) {
//       if (bp.mq.matches) {
//         scaleX = bp.scale;
//         return;
//       }
//     }
//     scaleX = 1.05; // default for smaller than 768px
//     yPoint = 420;
//   }

//   // Initial check
//   handleBreakpointChange();

//   // Listen for media query changes
//   breakpoints.forEach((bp) => bp.mq.addEventListener('change', handleBreakpointChange));

//   // Fallback: handle window resize
//   window.addEventListener('resize', handleBreakpointChange);

//   const HeroTl = gsap.timeline({
//     scrollTrigger: {
//       trigger: '.intro-section',
//       start: 'top 90%',
//       end: 'bottom 55%',
//       scrub: 1.07,
//       //markers: true,
//     },
//   });

//   HeroTl.to('.intro-section-lines .morph', {
//     morphSVG: (i, target) => {
//       const arcs = [
//         'M 22 250 A 250 250 0 0 1 578 250',
//         'M 44 250 A 200 200 0 0 1 556 250',
//         'M 66 250 A 150 150 0 0 1 534 250',
//         'M 88 250 A 100 100 0 0 1 512 250',
//         'M 110 250 A 50 50 0 0 1 490 250',
//       ];
//       return arcs[i];
//     },
//     y: yPoint,
//     scaleX: scaleX,
//     transformOrigin: 'center center',
//     duration: 1,
//     ease: 'power4.inOut',
//     opacity: 0.3,
//   });

//   HeroTl.to(
//     '.intro-section-lines .morph',
//     {
//       strokeDasharray: '4.7 4.7',
//     },
//     '<0.4'
//   );
// });
